import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Reflection, ReflectionValue } from '../models';

export const reflectionActions = createActionGroup({
    source: 'Reflection',
    events: {
        'Get Reflection': props<{ id: string }>(),
        'Get Reflection Success': props<{ payload: Reflection }>(),
        'Get Reflection Error': props<{ code: number; id: string }>(),

        'Create Reflection': props<{ value: ReflectionValue }>(),
        'Create Reflection Success': props<{ payload: Reflection }>(),
        'Create Reflection Error': props<{ code: number }>(),

        'Update Reflection': props<{ id: string; value: ReflectionValue }>(),
        'Update Reflection Success': props<{ payload: Reflection }>(),
        'Update Reflection Error': props<{ code: number }>(),

        'Delete Reflection': props<{ id: string }>(),
        'Delete Reflection Success': props<{ id: string }>(),
        'Delete Reflection Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
